'use client';

import { useRef } from 'react';
import { AttributeCard } from './AttributeCard';
import accelerateLottie from '../../assets/accelerate.json';
import observeLottie from '../../assets/observe.json';
import troubleshootLottie from '../../assets/troubleshoot.json';
import clsx from 'clsx';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { demoPageURI, attributePageURIs } from '../NavItems';

const cardData = [
  {
    title: 'Accelerate',
    lottie: accelerateLottie,
    bodyText: 'Stop waiting on slow builds & tests! Speed up feedback cycles so you can ship more features.',
    href: `${demoPageURI}/${attributePageURIs.ACCELERATE}/`,
  },
  {
    title: 'Troubleshoot',
    lottie: troubleshootLottie,
    bodyText: 'Find root cause faster. See which projects and users are affected. Identify and fix flaky tests.',
    href: `${demoPageURI}/${attributePageURIs.TROUBLESHOOT}/`,
  },
  {
    title: 'Observe',
    lottie: observeLottie,
    bodyText: 'Understand build/test health. See regressions right away. Monitor your metrics over time.',
    href: `${demoPageURI}/${attributePageURIs.OBSERVE}/`,
  },
];

interface AttributeCardProps {
  className: string;
}

export function AttributeCards({ className }: AttributeCardProps) {
  const containerRef = useRef(null);

  useGSAP(
    () => {
      gsap.fromTo(
        '#attribute-card',
        {
          autoAlpha: 0,
          y: 20,
        },
        { y: 0, autoAlpha: 1, stagger: { each: 0.05 }, duration: 0.25 },
      );
    },
    { scope: containerRef },
  );

  return (
    <div ref={containerRef} className={clsx('grid gap-6 md:grid-cols-2 lg:grid-cols-3', className)}>
      {cardData.map(({ title, bodyText, href, lottie }) => (
        <AttributeCard hasHeader key={title} title={title} bodyText={bodyText} lottie={lottie} href={href} />
      ))}
    </div>
  );
}
